import type { IProspectPartialOrder } from "@apis/prospects/types"
import { Button } from "@components/ui/button"
import { formatDate } from "@utils/formatters"
import { Link } from "react-router-dom"

type TProspectPartialOrderProps = {
  prospectPartialOrder: IProspectPartialOrder
  prospect_guid: string
}

export const ProspectPartialOrder = ({
  prospectPartialOrder,
  prospect_guid,
}: TProspectPartialOrderProps) => {
  return (
    <Button
      variant="outline"
      className="tw:h-fit tw:items-start tw:gap-1"
      asChild
    >
      <Link
        to={`/prospect/${prospect_guid}/new_order?order_id=${prospectPartialOrder.order_id}`}
        className="tw:flex tw:flex-col"
      >
        <span className="tw:text-wrap">
          Order date: {formatDate(prospectPartialOrder.order_dt)}
        </span>
        <span className="tw:text-wrap">
          ID: {prospectPartialOrder.order_id}
        </span>
        <span className="tw:text-wrap">
          Status: {prospectPartialOrder.order_status}
        </span>
        <span className="tw:text-wrap">
          Status Reason: {prospectPartialOrder.order_status_reason}
        </span>
      </Link>
    </Button>
  )
}
